import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import FamilyApi from "../../services/FamilyApi";
import { useToast } from "../../context/ToastContext";

// Design System
import Input from "../../components/Input/Input";
import FormCard from "../../components/FormCard/FormCard";

const FamilyDetails: React.FC = () => {
  const { t: translate } = useTranslation("form");
  const [nome, setNome] = useState("");
  const [description, setDescricao] = useState("");
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { displayToast } = useToast();

  useEffect(() => {
    FamilyApi.GetById(id)
      .then((response) => {
        const item = response?.data || null;
        if (!item) throw new Error(translate("errorLoadingFamily"));
        setNome(item.name);
        setDescricao(item.description);
        setCode(String(item.code));
      })
      .catch(() => {
        displayToast("error", translate("error"), translate("errorLoadingFamily"), false, 3000);
      });
  }, [id, displayToast, translate]);

  const handleBack = (): void => {
    navigate("/families");
  };

  return (
    <FormCard
      title={translate("detailsFamily")}
      icon="info"
      onSubmit={() => {}}
      onCancel={handleBack}
      cancelButtonLabel={translate("Cancel") || "Voltar"}
      numColumns={12}
      disabled
    >
      <div style={{ gridColumn: "span 12" }}>
        <Input
          type="text"
          label={translate("Name")}
          value={nome || "—"}
          disabled
          onChange={() => {}}
        />
      </div>
      
      <div style={{ gridColumn: "span 12" }}>
        <Input
          type="textArea"
          label={translate("description")}
          value={description || "—"}
          rows={3}
          disabled
          onChange={() => {}}
        />
      </div>

      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translate("code")}
          value={code || "—"}
          disabled
          onChange={() => {}}
        />
      </div>
    </FormCard>
  );
};

export default FamilyDetails;
